import { Vue } from 'vue-property-decorator';
import IconConstants from "@/lib/IconConstants";
import StatusDisplayLocation from '@/models/Shared/StatusDisplayLocation';
import PermissionType from '@/models/Settings/Roles/PermissionType'
import ComponentLocation from '@/models/Shared/ComponentLocation';
import EntityType from '@/models/Shared/EntityType';
import FieldValidationCodes from '@/lib/FieldValidationCodes';

export default class SaascadaVue extends Vue {
    public IconConstants = IconConstants;
    public StatusDisplayLocation = StatusDisplayLocation
    public ComponentLocation = ComponentLocation
    public PermissionType = PermissionType
    public EntityType = EntityType;

    validateField(field: string) {
        switch (field) {

            //Payee
            case FieldValidationCodes.PayeeSortCode:
                return this.stringFieldRules("Sort Code", 6, 6, true);
            case FieldValidationCodes.PayeeAccountNumber:
                return this.stringFieldRules("Account Number", 8, 8, true);
            case FieldValidationCodes.PayeeIBAN:
                return this.stringFieldRules("IBAN", 15, 34, true);
            //Payment Order
            case FieldValidationCodes.PaymentOrderCancelRejectReason:
                return this.stringFieldRules("Reason", 5, 255, true);
            //Person
            case FieldValidationCodes.Title:
                    return this.stringFieldRules("Title", 2, 20, true);
            case FieldValidationCodes.FirstName:
                return this.stringFieldRules("First Name", 2, 70, true);
            case FieldValidationCodes.LastName:
                return this.stringFieldRules("Last Name", 2, 70, true);
            case FieldValidationCodes.PhoneNumber:
                return [] = [((v: string) => /\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{1,14}$/.test(v) || 'Phone must be valid international format e.g. +44XXXXXXXXXX')]
            //Organisation
            case FieldValidationCodes.RegistrationNumber:
                return this.stringFieldRules("Registration Number", 2, 70, false);
            case FieldValidationCodes.OrganisationName:
                return this.stringFieldRules("Name", 2, 70, false);
            //Webhook
            case FieldValidationCodes.WebhookName:
                return this.stringFieldRules("Name", 5, 50, true);
            case FieldValidationCodes.WebhookUrl:
                return this.stringFieldRules("URL", 5, 255, true);
                //return [] = [((v: string) => new RegExp(`/^([a-z0-9+.-]+):(?:\/\/(?:((?:[a-z0-9-._~!$&'()*+,;=:]|%[0-9A-F]{2})*)@)?((?:[a-z0-9-._~!$&'()*+,;=]|%[0-9A-F]{2})*)(?::(\d*))?(\/(?:[a-z0-9-._~!$&'()*+,;=:@\/]|%[0-9A-F]{2})*)?|(\/?(?:[a-z0-9-._~!$&'()*+,;=:@]|%[0-9A-F]{2})+(?:[a-z0-9-._~!$&'()*+,;=:@\/]|%[0-9A-F]{2})*)?)(?:\?((?:[a-z0-9-._~!$&'()*+,;=:\/?@]|%[0-9A-F]{2})*))?(?:#((?:[a-z0-9-._~!$&'()*+,;=:\/?@]|%[0-9A-F]{2})*))?$/i`).test(v) || 'URL must be valid')]
            case FieldValidationCodes.TokenLifetime:
                return this.numberFieldRulesZeroNotAllowed("Token Lifetime", 1, 86400, true);
            case FieldValidationCodes.CSR:
                return this.stringFieldRules("CSR", 1, 10000, true);
            case FieldValidationCodes.Rate_Rate:
                return this.stringFieldRules("Rate", 1, 10, true);
            case FieldValidationCodes.Product_GeneralSettings_DefaultWalletCurrency:
                return this.stringFieldRules("Currency", 3, 3, true);

            // Shared Validation

            // Name (Max 70 characters, for fields shared with third parties)
            case FieldValidationCodes.Product_GeneralSettings_Name:
            case FieldValidationCodes.RateSource_Name:
            case FieldValidationCodes.Product_ManualFee_Name:
            case FieldValidationCodes.Product_ScheduledFee_Name:
            case FieldValidationCodes.Product_TransactionalFee_Name:
            case FieldValidationCodes.Product_SecondaryWalletType_Name:
            case FieldValidationCodes.Account_Wallets_SecondaryWalletName:
            case FieldValidationCodes.PublicHoliday_Name:
            case FieldValidationCodes.PaymentOrderName:
            case FieldValidationCodes.PayeeName:
            case FieldValidationCodes.GeneralLedger_AccountName:
                return this.stringFieldRules("Name", 4, 70, true);

            // Accoune Name (Similar to name but only allows special characters of hyphen, comma and full stop)
            case FieldValidationCodes.AccountName:
                var stringRules = this.stringFieldRules("Account Name", 6, 70, true);
                return stringRules.concat((v: string) => /^([a-zA-Z0-9]|\s|[-,.])*$/.test(v) || "Account name must consist of letters, numbers, spaces, a hyphen (-), a comma (,) or a full stop (.)");

            // Name (Max 250 characters, for internal SaaScada use only
            case FieldValidationCodes.AppMediumName:
            case FieldValidationCodes.Region_Name:
            case FieldValidationCodes.Role_Name:
            case FieldValidationCodes.ProductMigration_Name:
                return this.stringFieldRules("Name", 4, 250, true);

            // Code (Also has extra formatting regex test)
            case FieldValidationCodes.Product_GeneralSettings_Code:
            case FieldValidationCodes.ProductIssue_Code:
            case FieldValidationCodes.SubTransactionType_Code:
            case FieldValidationCodes.Product_SecondaryWalletType_Code:
                var stringRules = this.stringFieldRules("Code", 4, 30, true);
                return stringRules.concat((v: string) => /^([A-Z])[A-Z0-9-_]*$/.test(v) || "Code must consist of letters (A-Z), numbers (0-9), underscore (_) or hyphen (-) with no spaces");

            // Code (Number only no string)
            case FieldValidationCodes.GeneralLedger_AccountCode:
                return this.numberFieldRulesZeroNotAllowed("Code", 1, 999999, true);

            // Reference (35 chars, mandatory)
            case FieldValidationCodes.Product_ManualFee_Reference:
            case FieldValidationCodes.Product_ScheduledFee_Reference:
            case FieldValidationCodes.Product_TransactionalFee_Reference:
            case FieldValidationCodes.Account_Wallets_TransferDebitTransactionReference:
            case FieldValidationCodes.Account_Wallets_TransferCreditTransactionReference:
            case FieldValidationCodes.PayeeReference:
            case FieldValidationCodes.Tools_Adjustment_Reference:
                return this.stringFieldRules("Reference", 4, 35, true);

            // Reference (255 chars, not mandatory)
            case FieldValidationCodes.Account_OverrideTransactionReference:
                return this.stringFieldRules("Reference", 0, 255, false);

            // Email (75 chars, mandatory with extra regex formatting)
            case FieldValidationCodes.Email:
                var stringRules = this.stringFieldRules("Email", 0, 75, true);
                return stringRules.concat((v: string) => /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(v) || 'E-mail must be valid');

            // Address (various fields, not mandatory)
            case FieldValidationCodes.AddressLine1:
                return this.stringFieldRules("Address Line 1", 0, 100, false);
            case FieldValidationCodes.AddressLine2:
                return this.stringFieldRules("Address Line 2", 0, 100, false);
            case FieldValidationCodes.City:
                return this.stringFieldRules("City", 0, 50, false);
            case FieldValidationCodes.PostCode:
                return this.stringFieldRules("Postcode", 0, 50, false);
            case FieldValidationCodes.Country:
                return this.stringFieldRules("Country", 0, 2, false);

            // Address (various fields, mandatory)
            case FieldValidationCodes.AddressLine1Mandatory:
                return this.stringFieldRules("Address Line 1", 0, 100, true);
            case FieldValidationCodes.AddressLine2Mandatory:
                return this.stringFieldRules("Address Line 2", 0, 100, true);
            case FieldValidationCodes.CityMandatory:
                return this.stringFieldRules("City", 0, 50, true);
            case FieldValidationCodes.PostCodeMandatory:
                return this.stringFieldRules("Postcode", 0, 50, true);
            case FieldValidationCodes.CountryMandatory:
            case FieldValidationCodes.RegistrationCountry:
            case FieldValidationCodes.PayeeCountry:
                return this.stringFieldRules("Country", 2, 2, true);

            // Description (max 1000 chars, not mandatory)
            case FieldValidationCodes.Product_GeneralSettings_Description:
            case FieldValidationCodes.SubTransactionType_Description:
                return this.stringFieldRules("Description", 0, 1000, false);

            // Description (max 255 chars, mandatory with special characters check)
            case FieldValidationCodes.Fee_Description:
                var stringRules = this.stringFieldRules("Description", 1, 255, true);
                return stringRules.concat((v: string) => /^[a-zA-Z0-9\-_\s]*$/.test(v) || "Description must consist of letters (A-Z), numbers (0-9), underscore (_) or hyphen (-)");

            // Description (max 255 chars, not mandatory)
            case FieldValidationCodes.Account_StateChangeReasonDescription:
                return this.stringFieldRules("Description", 0, 255, false);

            // State
            case FieldValidationCodes.Account_State:
                return this.singleSelectRules("State");

            // State Reason Code
            case FieldValidationCodes.Account_StateChangeReasonCode:
                return this.singleSelectRules("State Change Code");

            // Amount
            case FieldValidationCodes.PaymentOrderAmount:
            case FieldValidationCodes.Account_Wallets_TransferAmount:
                return this.stringFieldRules("Amount", 3, 50, true);

            // Payee
            case FieldValidationCodes.PaymentOrderPayee:
                return this.singleSelectRules("Payee");

            // Scheme
            case FieldValidationCodes.PaymentOrderScheme:
                return this.singleSelectRules("Scheme");

            // Timezone
            case FieldValidationCodes.Region_Timezone:
                return this.singleSelectRules("Timezone");

            // Wallet
            case FieldValidationCodes.Account_Card_WalletID:
                return this.singleSelectRules("Wallet");

            // Person
            case FieldValidationCodes.Account_Card_Person:
                return this.singleSelectRules("Person");

            // Card Processor
            case FieldValidationCodes.Account_Card_Processor:
                return this.singleSelectRules("Card Processor");

            // Account Identifier
            case FieldValidationCodes.Account_Card_AccountIdentifier:
                return this.stringFieldRules("Account Identifier", 30, 50, true);

            // Culture
            case FieldValidationCodes.Region_DefaultCulture:
                return this.singleSelectRules("Culture");

            // Date
            case FieldValidationCodes.Rate_FromDate:
            case FieldValidationCodes.Product_DepositFixedTermSettings_FundingWindowStartDate:
            case FieldValidationCodes.Product_DepositFixedTermMaturitySettings_MaturityWindowStartDate:
            case FieldValidationCodes.Product_DepositFixedTermMaturitySettings_MaturityDate:
            case FieldValidationCodes.Reports_ReportDate:
                return this.stringDateFieldRules("Date");

            // Date (that must be in the future)
            case FieldValidationCodes.Account_ReviewDateUtc:
            case FieldValidationCodes.Product_DepositOverdraftSettings_ReviewDateUtc:
            case FieldValidationCodes.PaymentOrderScheduleStartDate:
                return this.stringDateFieldFutureDateOnlyRules("Date");

            // Schedule Frequency
            case FieldValidationCodes.PaymentOrderScheduleFrequency:
                return this.singleSelectRules("Schedule Frequency");

            // Type (Various)
            case FieldValidationCodes.PayeeType:
            case FieldValidationCodes.Reports_AccountType:
            case FieldValidationCodes.Reports_AccountSelection:
            case FieldValidationCodes.Reports_WalletSelection:
            case FieldValidationCodes.Product_TransactionalFee_TransactionType:
            case FieldValidationCodes.Tools_Adjustment_TransactionType:
            case FieldValidationCodes.Account_Wallets_SecondaryWalletType:
            case FieldValidationCodes.Account_Wallets_FXType:
            case FieldValidationCodes.Product_ScheduledFee_PeriodType:
            case FieldValidationCodes.Product_GeneralSettings_TargetCustomerType:
            case FieldValidationCodes.Product_DepositInterestSettings_PostingScheduleType:
                return this.singleSelectRules("Type");

            // Currency (Single Drop Down)
            case FieldValidationCodes.Account_Wallets_SecondaryWalletCurrency:
            case FieldValidationCodes.Account_Wallets_FXSellCurrency:
            case FieldValidationCodes.Account_Wallets_FXBuyCurrency:
            case FieldValidationCodes.Region_DefaultCurrency:
                return this.singleSelectRules("Currency");

            // Allowed Currency (Multi-Drop Down)
            case FieldValidationCodes.Product_SecondaryWalletType_AllowedCurrencies:
            case FieldValidationCodes.Region_AvailableCurrencies:
                return this.multiSelectRules("Currency");

            // General Ledger Name
            case FieldValidationCodes.Product_GeneralLedgerSettings_GeneralLedgerName:
                return this.singleSelectRules("General Ledger Name");

            // Source wallet
            case FieldValidationCodes.Account_Wallets_TransferSourceWallet:
                return this.singleSelectRules("Source wallet");

            // Destination wallet
            case FieldValidationCodes.Account_Wallets_TransferDestinationWallet:
                return this.singleSelectRules("Destination wallet");

            // Rate Value
            case FieldValidationCodes.Product_DepositInterestSettings_RateValue:
            case FieldValidationCodes.Product_DepositOverdraftInterestSettings_RateValue:
            case FieldValidationCodes.Product_SecondaryWalletType_RateValue:
                return this.numberFieldRulesMandatoryZeroAllowed("Rate", 0, 1000);

            // Rate Source ID
            case FieldValidationCodes.Product_DepositInterestSettings_RateSourceId:
            case FieldValidationCodes.Product_DepositOverdraftInterestSettings_RateSourceId:
            case FieldValidationCodes.Product_SecondaryWalletType_RateSourceId:
            case FieldValidationCodes.Product_LendingInterestSettings_RateSourceId:
                return this.singleSelectRules("Rate Source");

            // Debit/Credit Code
            case FieldValidationCodes.Tools_Adjustment_DebitCreditCode:
                return this.singleSelectRules("Debit/Credit Code");

            // Installments
            case FieldValidationCodes.Product_LendingScheduleSettings_NumberOfInstallments:
            case FieldValidationCodes.Product_LendingScheduleSettings_NumberOfInstallmentsMinimum:
            case FieldValidationCodes.Product_LendingScheduleSettings_NumberOfInstallmentsMaximum:
                return this.numberFieldRulesZeroNotAllowed("Number of Installments", 1, 30, true);

            // Due Date Offset
            case FieldValidationCodes.Product_LendingScheduleSettings_FirstDueDateOffsetPeriodValueMinimum:
            case FieldValidationCodes.Product_LendingScheduleSettings_FirstDueDateOffsetPeriodValueMaximum:
                return this.numberFieldRulesMandatoryZeroAllowed("Due Date Offset", 0, 30);

            // Product
            case FieldValidationCodes.Product_DepositFixedTermMaturitySettings_MaturityAction1ProductId:
            case FieldValidationCodes.ProductMigration_FromProduct:
                return this.singleSelectRules("Product");

            // Product Issue
            case FieldValidationCodes.ProductMigration_FromProductIssue:
            case FieldValidationCodes.ProductMigration_ToProductIssue:
                return this.singleSelectRules("Product Issue");

            // Accrued/Posted Period Value
            case FieldValidationCodes.Product_DepositInterestSettings_AccruedPeriodValue:
            case FieldValidationCodes.Product_DepositInterestSettings_PostedPeriodValue:
            case FieldValidationCodes.Product_DepositOverdraftInterestSettings_AccruedPeriodValue:
            case FieldValidationCodes.Product_DepositOverdraftInterestSettings_PostedPeriodValue:
            case FieldValidationCodes.Product_DepositFixedTermSettings_TermPeriodValue:
            case FieldValidationCodes.Product_DepositFixedTermSettings_InitialDepositWindowPeriodValue:
            case FieldValidationCodes.Product_DepositFixedTermSettings_FundingWindowPeriodValue:
            case FieldValidationCodes.Product_DepositCoolingOffSettings_CoolingOffPeriodValue:
            case FieldValidationCodes.Product_DepositInstantAccessSettings_InitialDepositWindowPeriodValue:
            case FieldValidationCodes.Product_DepositInstantAccessSettings_FundingWindowPeriodValue:
            case FieldValidationCodes.Product_DepositPaymentOrderSettings_NoticePeriodValue:
            case FieldValidationCodes.Product_SecondaryWalletType_AccruedPeriodValue:
            case FieldValidationCodes.Product_SecondaryWalletType_PostedPeriodValue:
            case FieldValidationCodes.Product_LendingTermSettings_TermPeriodValue:
            case FieldValidationCodes.Product_LendingInterestSettings_RateChangedPeriodValue:
            case FieldValidationCodes.Product_LendingInterestSettings_AccruedPeriodValue:
            case FieldValidationCodes.Product_LendingScheduleSettings_PaymentIntervalPeriodValue:
            case FieldValidationCodes.Product_LendingScheduleSettings_FirstDueDateOffsetPeriodValue:
            case FieldValidationCodes.Product_LendingScheduleSettings_GracePeriodValue:
                return this.numberFieldRulesZeroNotAllowed("Value", 1, 999999, true);

            // Accrued/Posted Period On Day Of Week
            case FieldValidationCodes.Product_DepositInterestSettings_AccruedPeriodOnDayOfWeek:
            case FieldValidationCodes.Product_DepositInterestSettings_PostedPeriodOnDayOfWeek:
            case FieldValidationCodes.Product_DepositOverdraftInterestSettings_AccruedPeriodOnDayOfWeek:
            case FieldValidationCodes.Product_DepositOverdraftInterestSettings_PostedPeriodOnDayOfWeek:
            case FieldValidationCodes.Product_ScheduledFee_PeriodOnDayOfWeek:
            case FieldValidationCodes.Product_SecondaryWalletType_AccruedPeriodOnDayOfWeek:
            case FieldValidationCodes.Product_SecondaryWalletType_PostedPeriodOnDayOfWeek:
            case FieldValidationCodes.Product_LendingInterestSettings_AccruedPeriodOnDayOfWeek:
                return this.singleSelectRules("Day of Week");

            // Accrued/Posted Period On Day Of Month
            case FieldValidationCodes.Product_DepositInterestSettings_AccruedPeriodOnDayOfMonth:
            case FieldValidationCodes.Product_DepositInterestSettings_PostedPeriodOnDayOfMonth:
            case FieldValidationCodes.Product_DepositOverdraftInterestSettings_AccruedPeriodOnDayOfMonth:
            case FieldValidationCodes.Product_DepositOverdraftInterestSettings_PostedPeriodOnDayOfMonth:
            case FieldValidationCodes.Product_ScheduledFee_PeriodOnDayOfMonth:
            case FieldValidationCodes.Product_SecondaryWalletType_AccruedPeriodOnDayOfMonth:
            case FieldValidationCodes.Product_SecondaryWalletType_PostedPeriodOnDayOfMonth:
            case FieldValidationCodes.Product_LendingInterestSettings_AccruedPeriodOnDayOfMonth:
                return this.singleSelectRules("Day of Month");

            // Accrued/Posted Period On Month
            case FieldValidationCodes.Product_DepositInterestSettings_AccruedPeriodOnMonth:
            case FieldValidationCodes.Product_DepositInterestSettings_PostedPeriodOnMonth:
            case FieldValidationCodes.Product_DepositOverdraftInterestSettings_AccruedPeriodOnMonth:
            case FieldValidationCodes.Product_DepositOverdraftInterestSettings_PostedPeriodOnMonth:
            case FieldValidationCodes.Product_ScheduledFee_PeriodOnMonth:
            case FieldValidationCodes.Product_SecondaryWalletType_AccruedPeriodOnMonth:
            case FieldValidationCodes.Product_SecondaryWalletType_PostedPeriodOnMonth:
            case FieldValidationCodes.Product_LendingInterestSettings_AccruedPeriodOnMonth:
                return this.singleSelectRules("Month");

        }
        return;
    }

    numberFieldRulesZeroNotAllowed(fieldName: string, min: number, max: number, mandatory: boolean) {
        if (mandatory) {
            return [] = [
                function(v: any) {
                    // This can come in as a string from vuetify
                    if (!Number.isInteger(parseFloat(v))) {
                        return `${fieldName} must be a whole number`;
                    }
                    return true;
                },
                (v: number) => !!v || `${fieldName} is required`,
                (v: number) => v >= min || `${fieldName} must be ${min} or more`,
                (v: number) => v <= max || `${fieldName} must not be more than ${max}`,
            ];
        }
        else {
            return [] = [
                (v: number) => v >= min || `${fieldName} must be ${min} or more`,
                (v: number) => v <= max || `${fieldName} must not be more than ${max}`,
            ];
        }
    }

    numberFieldRulesMandatoryZeroAllowed(fieldName: string, min: number, max: number) {
        return [] = [
            function(v: any) {
                if (isNaN(parseFloat(v))) {
                    return `${fieldName} is required`;
                }
                return true;
            },
            (v: number) => v >= min || `${fieldName} must be ${min} or more`,
            (v: number) => v <= max || `${fieldName} must not be more than ${max}`,
        ];
    }

    stringFieldRules(fieldName: string, min: number, max: number, mandatory: boolean) {
        if (mandatory) {
            return [] = [
                ( v: string ) => !!v || `${fieldName} is required`,
                ( v: string ) => v.length >= min || `${fieldName} must be ${min} or more characters`,
                ( v: string ) => v.length <= max || `${fieldName} must not be more than ${max} characters`,
            ];
        }
        else {
            return [] = [
                ( v: string ) => v.length >= min || `${fieldName} must be ${min} or more characters`,
                ( v: string ) => v.length <= max || `${fieldName} must not be more than ${max} characters`,
            ];
        }
    }

    stringDateFieldRules(fieldName: string) {
        return [] = [
            (v: string) => !!v || `${fieldName} is required`,
        ];
    }

    stringDateFieldFutureDateOnlyRules(fieldName: string) {
        return [] = [
            (v: string) => !!v || `${fieldName} is required`,
                function(v: any) {
                    const dateNow = new Date();
                    const dateToValidate = new Date(v);
                    if (dateToValidate < dateNow) {
                        return `${fieldName} must be in the future`;
                    }
                    return true;
                },
        ];
    }

    singleSelectRules(fieldName: string) {
        return [] = [
            (v: any) => !!v || `${fieldName} is required`,
        ];
    }

    multiSelectRules(fieldName: string) {
        return [] = [
            (v: any) => v.length > 0 || `${fieldName} is required`,
        ];
    }

    singleSelectEmptyIdRules(fieldName: string) {
        return [] = [
            function(v: any) {
                if (v .id=== '00000000-0000-0000-0000-000000000000' || v.id === undefined) {
                    return `${fieldName} is required`;
                }
                return true;
            },
        ];
    }
}